import React from 'react';
import { TaxTableProps } from './types';

const TaxTable: React.FC<TaxTableProps> = ({ title, slabs }) => {
  return (
    <table className="border-collapse w-[45%] sm:w-full">
      <caption className="font-bold sm:mt-4">{title}</caption>
      <thead>
        <tr>
          <th className="border p-2">Income Tax Slabs (Rs.)</th>
          <th className="border p-2">Income Tax Rates</th>
        </tr>
      </thead>
      <tbody>
        {slabs.map((slab, index) => (
          <tr key={index}>
            <td className="border p-2">{slab.slab}</td>
            <td className="border p-2">{slab.rate}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TaxTable;
